import { SGSForm } from 'components';
import SGSInputCurrency from 'components/SGSCurrency';
import { formHasField } from 'features/arretTravail/models/scenarii';
import { WorkedHours } from 'features/arretTravail/models/StopInformation/workStoppage';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type WorkStoppageCotisAmountSectionProps = {
    store: any;
};

/**
 * WorkStoppageCotisAmountSection component handles the conditional rendering
 * of the cotisation amount input field based on eligibility case and form state.
 */
const RightsS3201CotisAmount: React.FC<WorkStoppageCotisAmountSectionProps> = ({ store }) => {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    const [hasWorkStoppageCotisAmount, setHasWorkStoppageCotisAmount] = useState(false);

    const watchWorkedHours = watch('workStoppage.rights.workedHours');

    // Update display state whenever eligibility case or store changes
    useEffect(() => {
        setHasWorkStoppageCotisAmount(shouldDisplayCotisAmount(watchWorkedHours, store));
    }, [watchWorkedHours, store]);

    useEffect(() => {
        setHasWorkStoppageCotisAmount(shouldDisplayCotisAmount(watchWorkedHours, store));
    }, []);

    if (!hasWorkStoppageCotisAmount) {
        return null;
    }

    return (
        <SGSForm.Row>
            <SGSForm.Col md={6}>
                <SGSInputCurrency name="workStoppage.rights.contribution" label={t('workStop.fields.workStoppage.rights.contribution')} />
            </SGSForm.Col>
        </SGSForm.Row>
    );
};

export default RightsS3201CotisAmount;

/**
 * Determines whether the cotisation amount field should be displayed
 * based on the eligibility case and available form fields.
 *
 * @param {WorkedHours} watchWorkStoppageRightsCase - The eligibility case being watched.
 * @param {any} store - The form store containing configuration and values.
 * @returns {boolean} - True if the cotisation amount field should be displayed, otherwise false.
 */
const shouldDisplayCotisAmount = (watchWorkStoppageRightsCase: WorkedHours, store: any): boolean => {
    const validCases = [WorkedHours.Minus200, WorkedHours.Minus800];
    return validCases.includes(watchWorkStoppageRightsCase) && formHasField(['workStoppage.rights.contribution'], 'formAtFields', store);
};
